import { useState } from "react";
import CustomInputs from "../../common/Inputs";
import { FORM_CONTROLFIELD_TYPES } from "../../../constants/constants";
import { TEMPLATE_TEXT_MAX_LENGTH, exceedsTemplateTextLimit, templateTextLimitMessage } from "./templateTextLimits";

const CLAUSE_LABEL = "Application Fee Clause";

const FeeTemplete = ({ postData, setPostData, feeError = false, clauseError = false, clauseErrorMessage = "" }) => {
  const [clauseLimitError, setClauseLimitError] = useState("");
  const clauseMessage =
    clauseLimitError || (clauseError ? clauseErrorMessage || `${CLAUSE_LABEL} is required` : undefined);
  return (
    <>
      <div className="feeCard">
        <div className="fees_left_section">
          <CustomInputs
            name={undefined}
            type={FORM_CONTROLFIELD_TYPES?.TEXT}
            value={postData?.leaseApplicationTemplateSections?.ApplicationFees?.fee}
            labelText={"Application Fee"}
            isFormControl
            maxLength={10}
            onChange={(e) => {
              const inputValue = e.target.value;
              if (/^\d*\.?\d{0,2}$/.test(inputValue)) {
                setPostData((prev) => {
                  const newData = { ...prev };
                  newData.leaseApplicationTemplateSections = {
                    ...prev.leaseApplicationTemplateSections,
                    ApplicationFees: {
                      ...prev.leaseApplicationTemplateSections?.ApplicationFees,
                      fee: inputValue,
                    },
                  };
                  return newData;
                });
              }
            }}
            required
            disabled={undefined}
            placeholder={"Application Fee"}
            myClassName={undefined}
            isError={feeError}
            errorMessages={feeError ? "Application Fee is required" : undefined}
            width={"445px"}
            currencySymbol="$"
            currencyHeight="48px"
          /></div>
        <div className="fees_right_section">
          <CustomInputs
            name="signature"
            type={FORM_CONTROLFIELD_TYPES?.TEXT}
            value={postData?.leaseApplicationTemplateSections?.ApplicationFees?.clause}

            labelText={CLAUSE_LABEL}
            isFormControl
            // One over the limit so an over-long paste reaches onChange and shows the message
            // instead of being silently truncated by the native maxLength.
            maxLength={TEMPLATE_TEXT_MAX_LENGTH + 1}
            onChange={(e) => {
              if (exceedsTemplateTextLimit(e.target.value)) {
                setClauseLimitError(templateTextLimitMessage(CLAUSE_LABEL));
                return;
              }
              setClauseLimitError("");
              setPostData({
                ...postData,
                leaseApplicationTemplateSections: { ...postData.leaseApplicationTemplateSections, ApplicationFees: { ...postData?.leaseApplicationTemplateSections?.ApplicationFees, clause: e.target.value } }

              });
            }}
            required
            disabled={undefined}
            placeholder={"Enter Application Fee Clause"}
            myClassName={undefined}
            isError={clauseError || !!clauseLimitError}
            errorMessages={clauseMessage}
            width={"445px"}
            currencySymbol="$"
            currencyHeight="48px"
          />
          <div>

          </div>

        </div>
      </div>
    </>
  );
};

export default FeeTemplete;
